import Datagent                              from 'datagent';
import { respondData, requestHandle, isDef} from '../utils';
import {defaults}                            from 'datagent/src/utils';
import { getURL } from 'datagent/src/utils';

const {filter, format, getField, awaitTo} = Datagent.Hooks;
const isNew = data => !isDef(data.id) || !data.id

const name  = 'carbonCompany';
const Model = Datagent.Model({
    name,
    fields : {
        'id'                : {type: Number, default: null},
        'abbreviation': {type: String, default: ''}, //公司名称
        'companyName' : {type: String, default: ''}, // 公司全名
        'industryId'  : {type: Number, default: ''}, //行业id
        'stockCode'   : {type: String, default: ''}, // 股票代码,
        'companyType' : {type: String, default: ''}, // 公司类型0-未知；1-沪深；2-港股；3-美股,
        'industry'    : {type: String, default: ''}, // 行业名
        'industryList'    : {type: String, default: ''}, // 行业列表
    },
    methods: {
        find(params, opts){
            const { origin } = defaults(opts);
            const { type, ...query } = params
            const url = type == 'listed' ? `${type}Company` : this._url
            return this.remote(origin).get(`${url}`, { ...query });
        },
        fetch(params, opts){
            const { origin } = defaults(opts);
            return this.remote(origin).get(this._url, params);
        },
        baseList(params, opts){
            const { origin } = defaults(opts);
            if (typeof params.limit == 'undefined') params.limit = 999
            return this.remote(origin).get(`${this._url}/baseList`, params);
        },
        save(data, opts) {
            const { origin } = defaults(opts);
            const { id, type, ..._data } = data;
            const url = getURL(type == 'listed' ? `${type}Company` : this._url, id, this._emulateIdKey);
            return this.remote(origin)[isNew(data) ? 'post' : 'put'](url, _data);
        },
        exportCompany(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params;
            const url = type == 'listed' ? `${type}Company` : this._url
            return this.remote(origin).get(`${url}/list/export`, query)
        },

        /**
        * 公司交易所列表
        *
        * @param {number} params.companyType 上市类型筛选，0-未上市；1-A股；2-港股；3-美股
        * @param {*} opts
        * @returns
        */
        exchange(params = {}, opts) {
            const { origin } = defaults(opts);
            const { limit = 999, ...query } = params
            return this.remote(origin).get(`${this._url}/exchange`, { ...query, limit });
        },
        /**
         * 公司板块类别
         *
         * @param {number} params.companyType 上市类型筛选，0-未上市；1-A股；2-港股；3-美股
         * @param {number} params.exchange 交易所筛选
         * @param {*} opts
         * @returns
         */
        plate(params = {}, opts) {
            const { origin } = defaults(opts);
            const { limit = 999, ...query } = params
            return this.remote(origin).get(`${this._url}/plate`, { ...query, limit });
        },
        /**
         * 国家列表
         *
         * @param {*} [params={}]
         * @param {*} opts
         * @returns
         */
        country(params = {}, opts) {
            const { origin } = defaults(opts);
            const { limit = 999, ...query } = params
            return this.remote(origin).get(`${this._url}/country`, { ...query, limit });
        },
        /**
         * 省份列表
         *
         * @param {*} [params={}]
         * @param {*} opts
         * @returns
         */
        province(params = {}, opts) {
            const { origin } = defaults(opts);
            const { limit = 999, ...query } = params
            return this.remote(origin).get(`${this._url}/province`, { ...query, limit });
        },
        /**
         * 城市列表
         *
         * @param {string} params.province 省份
         * @param {*} opts
         * @returns
         */
        city(params = {}, opts) {
            const { origin } = defaults(opts);
            const { limit = 999, ...query } = params
            return this.remote(origin).get(`${this._url}/city`, { ...query, limit });
        },
        /**
         * 区列表
         *
         * @param {string} params.city 城市
         * @param {*} opts
         * @returns
         */
        area(params = {}, opts) {
            const { origin } = defaults(opts);
            const { limit = 999, ...query } = params
            return this.remote(origin).get(`${this._url}/area`, { ...query, limit });
        },
        /**
         * 公司组织形式列表
         *
         * @param {object} params
         * @param {*} opts
         * @returns
         */
        ownership(params = {}, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/ownership`, { ...params });
        },
    },
    hooks  : {
        fetch              : {after: [respondData(), requestHandle()]},
        find               : {after: [respondData(), requestHandle()]},
        baseList           : { after: [respondData(), requestHandle(), format()] },
        exportCompany      : { after: [respondData(), requestHandle()] },
        save               : { before: [filter(['abbreviation', 'stockCode','companyName','companyType','industryIdList','industryId','isDelete','id','type'])], after: [respondData(), requestHandle()] }
    }
});

Model.ModelName   = name;
Model.validation = function (type) {
  const result = {
      abbreviation: [
          { required: true, type: 'string', message: '请输入公司简称', trigger: 'change' }
      ],
      companyName: [
          { required: true, type: 'string', message: '请输入公司全称', trigger: 'change' }
      ],
      companyType: [
          { required: true, type: 'number', message: '请选择上市类型', trigger: 'change' }
      ],
      isDelete: [
          { required: true, type: 'number', message: '请选择公司状态', trigger: 'change' }
      ],
      industryIdList: [
          { required: true, type: 'array', message: '请选择公司所在行业', trigger: 'change' }
      ],
      industryId: [
          { required: true, type: 'number', message: '请选择公司所在行业', trigger: 'change' }
      ],
  }
  if(type=='listed') delete result.industryIdList
  return result
};
export default Model;
